import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import styled from 'styled-components';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
} from '../atom/ModalAtom';
import Header2 from '../component/Header2';
import { searchPasswordRecoil } from '../atom/UserAtom';
import { authAPI } from '../api/axiosIndex';

const PasswordSearch = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const navigate = useNavigate();

  const [id, setId] = useState('');
  const [phoneNum, setPhoneNum] = useState('');
  const [phoneNumSend, setPhoneNumSend] = useState(false);
  const [phoneNumCertificationId, setPhoneNumCertificationId] = useState('');
  const [certificationNum, setCertificationNum] = useState('');
  const [phoneNumCertification, setPhoneNumCertification] = useState(false);
  const [timeLeft, setTimeLeft] = useState<number>(180);
  const [timerActive, setTimerActive] = useState<boolean>(false);

  const [searchPassword, setSearchPassword] =
    useRecoilState(searchPasswordRecoil);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (timerActive && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    }

    return () => {
      clearInterval(timer);
    };
  }, [timerActive, timeLeft]);

  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  const validatePhoneNumber = (number: string): boolean => {
    const phoneNumberRegex = /^010\d{8}$/;
    return phoneNumberRegex.test(number);
  };

  const handlePhoneNumCertificationSend = async () => {
    if (id === '') {
      setError('아이디를 입력해 주세요.');
      return;
    }

    if (phoneNum === '') {
      setError('휴대폰 번호를 입력해 주세요.');
      return;
    }

    if (!validatePhoneNumber(phoneNum)) {
      setError('휴대폰 번호 형식이 올바르지 않습니다.');
      return;
    }

    try {
      const res = await authAPI.postPasswordSerachPhoneNumCertification(
        id,
        phoneNum,
      );
      setPhoneNumCertificationId(res.data.uuid);
      setSearchPassword(res.data.uuid);
      setConfirm('인증번호 발송이 완료되었습니다.');
      setPhoneNumSend(true);
      setTimeLeft(180);
      setPhoneNumCertification(true);
      setTimerActive(true);
    } catch (err: any) {
      setError(
        '해당 휴대폰 번호로 가입된 아이디가 존재하지 않거나\n아이디와 휴대폰 번호가 일치하지 않습니다.',
      );
    }
  };

  const handlePasswordSearch = async () => {
    if (phoneNum === '' || certificationNum === '') {
      setError(blankMsg);
      return;
    }

    if (!phoneNumCertification) {
      setError('휴대폰 번호와 인증 번호를 확인해 주세요.');
      return;
    }

    if (certificationNum === '') {
      setError('인증 번호를 입력해 주세요.');
      return;
    }

    if (timeLeft === 0) {
      setTimerActive(false);
      setError(
        '인증번호 유효시간이 만료되었습니다.\n재발송 후 시도하여 주세요.',
      );
      return;
    }

    try {
      await authAPI.postPasswordSerachCertificationNumConfirm(
        phoneNumCertificationId,
        certificationNum,
      );
      navigate('/passwordsearchresult');
    } catch (err: any) {
      setError('인증 번호가 일치하지 않습니다.');
    }
  };

  return (
    <>
      <Header2 title={'비밀번호 찾기'} />
      <LS.LoginCntLayout>
        <CS.LoginInputWrap>
          <CS.LoginInputType>
            <h1>아이디</h1>
            <div>
              <input
                type="text"
                placeholder="아이디 입력"
                value={id}
                onChange={(e) => setId(e.target.value)}
              />
            </div>
          </CS.LoginInputType>
          <CS.LoginInputType>
            <h1>휴대폰 번호</h1>
            <div>
              <input
                type="text"
                placeholder="휴대폰 번호 입력 (-자 제외)"
                value={phoneNum}
                maxLength={11}
                onChange={(e) => {
                  setPhoneNum(e.target.value);
                  setCertificationNum('');
                  setPhoneNumSend(false);
                  setPhoneNumCertification(false);
                }}
              />
              <button
                type="button"
                onClick={handlePhoneNumCertificationSend}
                className={phoneNumSend ? 'retry' : ''}
              >
                {phoneNumSend ? '재발송' : '본인인증'}
              </button>
            </div>
          </CS.LoginInputType>
          <CS.LoginInputType>
            <h1>인증 번호</h1>
            <div>
              <input
                type="text"
                placeholder="인증번호"
                value={certificationNum}
                onChange={(e) => setCertificationNum(e.target.value)}
              />
              <span
                className={timeLeft === 0 ? 'time-text timezero' : 'time-text'}
              >
                {formatTime(timeLeft)}
              </span>
            </div>
          </CS.LoginInputType>
        </CS.LoginInputWrap>
      </LS.LoginCntLayout>
      <LS.LoginBtnLayout>
        <CS.Btn1Type1 type="button" onClick={handlePasswordSearch}>
          비밀번호 찾기
        </CS.Btn1Type1>
      </LS.LoginBtnLayout>
    </>
  );
};

export default PasswordSearch;
